// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Layout_wrapper__WlAdO","content":"Layout_content__Nj4Ig"};